import { Component, Prop } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import { BCollapse } from "@/lib/typed-bootstrap";
import DropdownsState, {
  DropdownStateEnum,
} from "@/mixins/DropdownsState.mixin";
import styles from "./CollapsibleSection.component.module.scss"; // assuming you have CSS modules!

@Component
export default class CollapsibleSection extends DropdownsState {
  _tsx!: tsx.DeclareProps<{
    id: string;
  }> &
    tsx.DeclareOnEvents<{}>;

  $scopedSlots!: tsx.InnerScopedSlots<{
    default: { isOpen: boolean };
  }>;

  @Prop({ required: true }) id!: string;

  toggleId = "collapsibleSection";

  get isOpen() {
    return this.dropDownState[this.toggleId] === DropdownStateEnum.shown;
  }

  render() {
    return (
      <div class={styles.section}>
        <button
          onClick={() => this.toggleDropdown(this.toggleId)}
          class={styles.toggleButton}
          aria-controls={this.id}
          aria-expanded={this.isOpen}
          data-testid={`${this.id}Toggle`}
        >
          <span class={styles.toggleTitle}>
            <img
              src={require("@/assets/img/down-arrow.svg")}
              class={[styles.icon, this.isOpen && styles.rotate]}
            />
            {this.$t("api_settings_custom_keys")}
          </span>
          <span class={[styles.fakeButton, this.isOpen && styles.hidden]}>
            {this.$t("global_expand")}
          </span>
        </button>

        <BCollapse
          id={this.id}
          visible={this.isOpen}
          class={styles.collapsible}
          on={{
            shown: () => this.showDropdown(this.toggleId),
            hidden: () => this.hideDropdown(this.toggleId),
          }}
        >
          {this.$scopedSlots.default?.({ isOpen: this.isOpen })}
        </BCollapse>
      </div>
    );
  }
}
